import React from 'react';
import { coaches } from '../data/coaches';

/**
 * Pre-launch version: no rating claim yet. Once there are real reviews,
 * add the stars and the real average + count back here.
 */
export function RatingProof() {
  const faces = coaches.slice(0, 5);
  return <div className="flex items-center gap-3" data-id="element-269" data-mp="3bor4qm70m330">
      <div className="flex -space-x-2.5" data-id="element-270" data-mp="3ghkddl5ltvkd">
        {faces.map(coach => <img key={coach.name} src={coach.avatar} alt="" width={36} height={36} className="h-9 w-9 rounded-full object-cover ring-2 ring-plum-deep" data-id="element-271" data-mp="3lgndqsan3dm0" />)}
      </div>
      <p className="text-[13px] leading-snug text-white/75" data-id="element-272" data-mp="3uhv14fbmau1b">
        <span className="font-semibold text-white" data-id="element-273" data-mp="3b0qbpr42b71">Made for teachers</span> of
        <br className="sm:hidden" data-id="element-274" data-mp="203amokdw3uqd" /> recreational groups, ages 6–12
      </p>
    </div>;
}